<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<!-- Google tag (gtag.js) -->
<script>
import CryptoJS from 'crypto-js'
export default {
  name: 'App',
  data () {
    return {
      googleJsId: ''
    }
  },
  created () {
    var inPageTime = parseInt(new Date().getTime())
    var fromPage = ''
    if (this.$router.history._startLocation.split('/')['2'] !== undefined) {
      fromPage = this.$router.history._startLocation.split('/')['2'].split('?')['0']
    }
    var toPage = this.$router.history.current.name
    var data = {
      'toPage': toPage,
      'fromPage': fromPage,
      'inPageTime': inPageTime,
      'outPageTime': ''
    }
    var datajson = JSON.stringify(data)
    sessionStorage.setItem('pageInfoData', datajson)

    this.trackPageView(toPage)

    // google js
    var site = this.common.siteSet()
    if (site === 'www') {
      // this.googleJsId = 'G-3VRF7Y39K2'
    } else {
      this.googleJsId = 'G-NMTFPDTHTG'
      const script = document.createElement('script')
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.googleJsId
      script.async = true
      document.body.appendChild(script)

      this.sendGoogleAnalysis('js', new Date())
      this.sendGoogleAnalysis('config', this.googleJsId)
    }

    // 获取初始访问链接
    if (sessionStorage.getItem('roompaiAccessLink') === null) {
      sessionStorage.setItem('roompaiAccessLink', this.$route.fullPath)
    }
    // 获取链接参数
    this.common.webLinkQuerys(this.$route.params)
  },
  mounted () {
    // 创建一个隐藏的 Canvas 元素
    var canvas = document.createElement('canvas')
    canvas.width = 200
    canvas.height = 200
    canvas.style.display = 'none'
    document.body.appendChild(canvas)

    // 获取 2D 上下文
    var context = canvas.getContext('2d')
    // 在 Canvas 上绘制一些内容
    context.textBaseline = 'alphabetic'
    context.fillStyle = '#f60'
    context.fillRect(125, 1, 62, 20)
    context.fillStyle = '#069'
    context.font = '11pt no-real-font-123'
    context.fillText('Cwm fjordbank glyphs vext quiz', 2, 15)
    context.fillStyle = 'rgba(102, 204, 0, 0.2)'
    context.font = '18pt Arial'
    context.fillText('Cwm fjordbank glyphs vext quiz', 4, 45)
    // 获取 Canvas 数据
    var imageData = context.getImageData(0, 0, canvas.width, canvas.height)
    var data = imageData.data
    // 计算指纹
    var hash = 0
    for (var i = 0; i < data.length; i += 4) {
      hash += data[i] + data[i + 1] + data[i + 2]
    }
    hash = hash.toString(16)
    // 移除 Canvas 元素
    document.body.removeChild(canvas)

    const navigatorInfo = {
      canvasData: hash,
      userAgent: window.navigator.userAgent,
      platform: window.navigator.platform,
      language: window.navigator.language,
      hardwareConcurrency: window.navigator.hardwareConcurrency,
      vendor: window.navigator.vendor,
      numberingSystem: Intl.DateTimeFormat().resolvedOptions().numberingSystem,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      width: window.screen.width,
      height: window.screen.height,
      plugins: this.getPluginsInfo(window.navigator.plugins),
      connection: this.getConnectionInfo(window.navigator.connection),
      WebGL: this.generateWebGLFingerprint(),
      webFont: this.webFont()

      // appVersion: window.navigator.appVersion,
      // appName: window.navigator.appName,
      // appCodeName: window.navigator.appCodeName,
      // languages: window.navigator.languages,
      // cookieEnabled: window.navigator.cookieEnabled,
      // doNotTrack: window.navigator.doNotTrack,
      // onLine: window.navigator.onLine,
      // geolocation: window.navigator.geolocation,
      // mediaDevices: window.navigator.mediaDevices,
      // vendorSub: window.navigator.vendorSub,
      // product: window.navigator.product,
      // productSub: window.navigator.productSub,
      // userAgentData: window.navigator.userAgentData,
      // mimeTypes: this.getMimeTypesInfo(window.navigator.mimeTypes),
      // maxTouchPoints: window.navigator.maxTouchPoints,
      // clipboard: this.getClipboardInfo(window.navigator.clipboard)
    }

    // 拼接字符串
    var navigatorInfoConcat = this.concatenateValues(navigatorInfo)
    console.log(navigatorInfo)
    console.log(navigatorInfoConcat)

    var navigatorInfoMd5 = this.$md5(navigatorInfoConcat + this.common.lfSignKey)
    console.log(navigatorInfoMd5)
    var hashResultBase64 = btoa(navigatorInfoConcat).toString()
    console.log(hashResultBase64)
  },
  methods: {
    getPluginsInfo: function (plugins) {
      const pluginInfo = []
      for (let i = 0; i < plugins.length; i++) {
        const plugin = plugins[i]
        // pluginInfo.push({
        //   name: plugin.name,
        //   filename: plugin.filename,
        //   description: plugin.description
        // })
        pluginInfo.push(plugin.name)
      }
      return pluginInfo.join(' | ')
    },
    getMimeTypesInfo: function (mimeTypes) {
      const mimeTypeInfo = []
      for (let i = 0; i < mimeTypes.length; i++) {
        const mimeType = mimeTypes[i]
        mimeTypeInfo.push({
          type: mimeType.type,
          description: mimeType.description,
          suffixes: mimeType.suffixes
        })
      }
      return mimeTypeInfo
    },
    getConnectionInfo: function (connection) {
      if (connection) {
        // return {
        //   type: connection.type,
        //   effectiveType: connection.effectiveType,
        //   downlink: connection.downlink,
        //   rtt: connection.rtt,
        //   saveData: connection.saveData
        // }
        return connection.effectiveType
      }
      return null
    },
    getClipboardInfo: function (clipboard) {
      if (clipboard) {
        return {
          read: typeof clipboard.read === 'function',
          write: typeof clipboard.write === 'function'
        }
      }
      return null
    },
    concatenateValues: function (obj) {
      let result = ''
      for (const key in obj) {
        result += obj[key] + ' !|! '
      }
      return result
    },
    compressString: function (str) {
      let encrypted = str
      for (let i = 0; i < 10; i++) {
        encrypted = CryptoJS.AES.encrypt(encrypted, this.common.lfSignKey).toString()
      }
      return encrypted
    },
    decompressString: function (str) {
      let decrypted = str
      for (let i = 0; i < 10; i++) {
        decrypted = CryptoJS.AES.decrypt(decrypted, this.common.lfSignKey).toString(CryptoJS.enc.Utf8)
      }
      return decrypted
    },
    generateWebGLFingerprint: function () {
      try {
        // 创建一个 WebGL 上下文
        const canvas = document.createElement('canvas')
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')

        if (!gl) {
          return 'WebGL not supported, unable to generate fingerprint.'
        }

        // 查询 WebGL 上下文的参数
        const fingerprintData = {
          version: gl.getParameter(gl.VERSION),
          renderer: gl.getParameter(gl.RENDERER),
          vendor: gl.getParameter(gl.VENDOR),
          extensions: gl.getSupportedExtensions()
        }

        // 生成指纹
        const fingerprint = JSON.stringify(fingerprintData)

        return fingerprint
      } catch (error) {
        console.error('Error generating WebGL fingerprint:', error)
        return 'Error generating WebGL fingerprint.'
      }
    },
    webFont: function () {
      // 创建一个临时的 <span> 元素，用于测试字体
      const testElement = document.createElement('span')
      testElement.style.fontFamily = 'initial' // 设置为默认字体
      testElement.style.display = 'none'
      document.body.appendChild(testElement)
      const computedStyle = window.getComputedStyle(testElement)
      const defaultFont = computedStyle.fontFamily
      document.body.removeChild(testElement)

      // 打印系统字体列表
      return defaultFont
    }
  }
}
</script>
<style type="text/css">
  /* @import "./assets/font/font.css"; */
  body{
    /* font-family: 'PingFang SC'; */
    font-family: PingFangSCRegular, 'PingFang SC', sans-serif;
  }
  /*loading*/
  /deep/ .el-loading-mask.is-fullscreen{z-index:10010!important;}

  #nprogress{position: fixed !important ;top: 0px !important ;z-index: 10000 !important ;}
  #nprogress .bar {background: #fcd205 !important ;}
  #nprogress .peg {box-shadow: 0 0 10px #fcd205, 0 0 5px #fcd205 !important ;}
  #nprogress .spinner-icon {border-top-color: rgb(1,1,1,0) !important ;border-left-color: rgb(1,1,1,0) !important ;}
  .el-scrollbar .el-scrollbar__bar { opacity: 1 !important;}
  .el-drawer {outline: none!important;}
  .mobile-el-message {min-width: 100%;}
  .wechatBindCancelButton {width: 131px;height: 36px;background-color: rgb(83, 146, 249);border: none;border-radius: 6px;box-shadow: none;font-weight: 400;font-size: 16px;color: #FFFFFF;text-align: center;}
  .room-order-tips-info ul{ margin-left:15px !important;}
  .v-modal{z-index: 1990!important;}

  /*不可修改的input底色及字体颜色处理*/
  input:disabled{background-color: #F5F7FA !important;border-color: #E4E7ED !important;color: #C0C4CC !important;cursor: not-allowed;}
  /*登录页面的tab选项卡宽度控制*/
  #loginTabs .el-tabs__nav{width: 100%}
  #loginTabs .el-tabs__item{width: 50% !important;text-align: center}
</style>



// WEBPACK FOOTER //
// src/App.vue